import React from "react";
import Select from "react-select";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import CreatableSelect from "react-select/creatable";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import clsx from "clsx";
import Header from "components/Headers/Header";
import { UUIDv4 } from "uuid-v4-validator";
import { ErrorMessage, Formik } from "formik";
import { createWebtoon } from "utils/endpoint";
import {
  get_universes_list,
  get_status_list,
  get_author_list,
  get_Illustrator_list,
  get_type_list,
  get_genre_list,
  get_public_list,
} from "utils/Commen";
import UseFullPageLoader from "utils/UseFullPageLoader";
import { onGoing } from "utils/enums";
import { isActive } from "utils/enums";
import CreateUniverses from "utils/CreateUniverses";
import { get_User_list } from "utils/Commen";
import { verifyUniqueWebtoonJPTitle } from "utils/endpoint";
import ProtectedRoute from "components/ProtectedRoute";
import HasPermission from "components/HasPermission";
const validationSchema = yup.object({
  en_title: yup.string().required("EN Title is required"),
});

const CreateWebtoon = () => {
  const [show, setShowModal] = useState(false);
  const [loader, showLoader, hideLoader] = UseFullPageLoader();
  const [universeList, setUniverseList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [authorList, setAuthorList] = useState([]);
  const [illustratorList, setIllustratorList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [genreList, setGenreList] = useState([]);
  const [publicList, setPublicList] = useState([]);
  const [flagList, setFlagList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAuthors, setSelectedAuthors] = React.useState([]);
  const [selectedPublicTargeted, setSelectedPublicTargeted] = React.useState([]);
  const [selectedIllustrator, setSelectedIllustrator] = React.useState([]);
  const [selectedGenre, setSelectedGenre] = React.useState([]);
  const [permissions, setPermissions] = useState([]);
  const [file, setFile] = useState();
  const [resultImages, setResultImages] = useState({});
  const [isJpTitleUnique, setIsJpTitleUnique] = useState(null);
  const [jpTitle, setJpTitle] = useState("")
  const navigate = useNavigate();
  const getUniverseList = async () => {
    const allUniverses = await get_universes_list();
    setUniverseList([{ id: "", name: "None" }, ...allUniverses]);
  };
  const getStatusList = async () => {
    const allStatus = await get_status_list();
    setStatusList([{ id: "", name: "None" }, ...allStatus]);
  };

  const getAuthorList = async () => {
    const allAuthors = await get_author_list();
    setAuthorList(allAuthors);
  };
  const getIllustratorList = async () => {
    const illustrator = await get_Illustrator_list();
    setIllustratorList(illustrator);
  };
  const getTypeList = async () => {
    const allTYpe = await get_type_list();
    setTypeList([{ id: "", name: "None" }, ...allTYpe]);
  };
  const getGenreList = async () => {
    const allGenre = await get_genre_list();
    setGenreList(allGenre);
  };
  const getPublicList = async () => {
    const allPublic = await get_public_list();
    setPublicList(allPublic);
  };
  const getFlagList = async () => {
    const allFlag = await get_User_list();
    setFlagList(allFlag)
  }
  useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem("User"));
    if (loginData) {
      setPermissions(loginData.permissions);
    }
    getUniverseList();
    getStatusList();
    getPublicList();
    getAuthorList();
    getIllustratorList();
    getTypeList();
    getGenreList();
    getFlagList()

  }, []);

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = () => {
        const baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const onSelectFile = (event) => {
    const selectedFiles = event.target.files;
    setFile(URL.createObjectURL(event.target.files[0]));
    const selectedFilesArray = Array.from(selectedFiles);
    for (let i = 0; i < selectedFilesArray.length; i++) {
      const name = selectedFilesArray[i].name;
      getBase64(selectedFilesArray[i])
        .then((result) => {
          const imageArrays = { file_name: name, image_data: result };
          setResultImages(imageArrays);
        })
        .catch((err) => { });
    }
    event.target.value = "";
  };

  const checkUniqueJPTitle = async () => {
    if (!jpTitle) return;
    const response = await verifyUniqueWebtoonJPTitle({ jp_title: jpTitle });
    if (response) {
      setJpTitle(response?.data?.jp_title);
      setIsJpTitleUnique(response.isSuccess)
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{
        en_title: "",
        universe_id: "",
        status_id: "",
        jp_title: "",
        kr_title: "",
        no_of_volumes: "",
        ongoing: "",
        type_id: "",
        jp_platform: "",
        kr_platform: "",
        us_platform: "",
        fr_platform: "",
        jp_platform_likes: "",
        kr_platform_likes: "",
        us_platform_likes: "",
        fr_platform_likes: "",
        jp_wikipedia_link: "",
        kr_wikipedia_link: "",
        scantrad: "",
        jp_raw: "",
        low_sales: "",
        medium_sales: "",
        high_sales: "",
        fr_consumer_price: "",
        comment: "",
        is_active: "",
        author_ids: [],
        illustrator_ids: [],
        new_authors: [],
        new_illustrators: [],
        genre_ids: [],
        public_ids: [],
        flag_users: [],
        product_pl: "",

      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
        setLoading(true);
        showLoader()
        const $inputData = {
          en_title: values.en_title,
          universe_id: values.universe_id,
          status_id: values.status_id,
          jp_title: values.jp_title,
          kr_title: values.kr_title,
          no_of_volumes: values.no_of_volumes,
          ongoing: values.ongoing,
          type_id: values.type_id,
          jp_platform: values.jp_platform,
          kr_platform: values.kr_platform,
          us_platform: values.us_platform,
          fr_platform: values.fr_platform,
          jp_platform_likes: values.jp_platform_likes,
          kr_platform_likes: values.kr_platform_likes,
          us_platform_likes: values.us_platform_likes,
          fr_platform_likes: values.fr_platform_likes,

          jp_wikipedia_link: values.jp_wikipedia_link,
          kr_wikipedia_link: values.kr_wikipedia_link,
          scantrad: values.scantrad,
          jp_raw: values.jp_raw,
          low_sales: values.low_sales,
          medium_sales: values.medium_sales,
          high_sales: values.high_sales,
          fr_consumer_price: values.fr_consumer_price,
          comment: values.comment,
          is_active: values.is_active,
          author_ids: values.author_ids,
          illustrator_ids: values.illustrator_ids,
          new_authors: values.new_authors,
          new_illustrators: values.new_illustrators,
          genre_ids: values.genre_ids,
          public_ids: values.public_ids,
          flag_users: values.flag_users,
          image: resultImages,
          product_pl: values.product_pl,

        };

        const finalObj = {};
        Object.keys($inputData).forEach(function (key) {
          if (typeof $inputData[key] === "string" && $inputData[key]) {
            finalObj[key] = $inputData[key];
          }
          if (typeof $inputData[key] === "number" && $inputData[key]) {
            finalObj[key] = $inputData[key];
          }
          if (typeof $inputData[key] === "boolean" && $inputData[key]) {
            finalObj[key] = $inputData[key];
          }
          if (
            typeof $inputData[key] === "object" &&
            $inputData[key].length > 0
          ) {
            finalObj[key] = $inputData[key];
          }
        });

        if (resultImages) {
          finalObj.image = resultImages;
        }

        finalObj.universe_id = finalObj?.universe_id ? finalObj?.universe_id : null;
        finalObj.status_id = finalObj?.status_id ? finalObj?.status_id : null;
        finalObj.type_id = finalObj?.type_id ? finalObj?.type_id : null;
        finalObj.ongoing = finalObj?.ongoing !== "none" ? finalObj?.ongoing : null;

        const result = await createWebtoon(finalObj);

        if (result?.isSuccess) {
          toast.success("Webtoon created successfully");
          setLoading(false);
          hideLoader()
          resetForm();
          navigate("/admin/webtoon/webtoon-list");
        } else {
          setSubmitting(false);
          setLoading(false);
          hideLoader()
          return toast.error(
            result.message || `Something went wrong, please try again letter!`
          );
        }
      }}>
      {({
        handleChange,
        handleSubmit,
        values,
        errors,
        touched,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} autoComplete="off">
          <>
            <Header />

            <Container className="mt--7" fluid>
              <Row>
                <div className="col">
                  <Card className="shadow">
                    <CardHeader className="border-0">
                      <Row>
                        <Col lg="6">
                          <h1 className="mb-0">Create Webtoon</h1>
                        </Col>
                        <Col lg="6" className="add_btn text-right">
                          <Button
                            color="primary"
                            className=""
                            onClick={() => {
                              navigate("/admin/webtoon/webtoon-list");
                            }}>
                            <span className="me-2">Back</span>
                          </Button>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label required">
                              EN Title
                            </label>
                            <Input
                              className={clsx("form-control", {
                                "is-invalid":
                                  Boolean(errors.en_title) && touched.en_title,
                              })}
                              id="en_title"
                              name="en_title"
                              placeholder="EN Title"
                              type="text"
                              value={values.en_title}
                              onChange={handleChange}
                            />
                            <div className="text-danger text-align-top-center mt-1">
                              <ErrorMessage name="en_title" />
                            </div>
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <Row className="form-control-label">
                              <Col lg="6">
                                <span className="">Universe</span>
                              </Col>

                              <Col lg="6" className="add_btn text-right">
                                <Button
                                  className="btn-sm ml-10 text-right"
                                  color="primary"
                                  onClick={async () => {
                                    setShowModal(true);
                                  }}>
                                  +
                                </Button>
                              </Col>
                            </Row>
                            <Select
                              name="universe_id"
                              id="universe_id"
                              className="react-select mt-2"
                              options={Array.from(universeList).map((value) => {
                                return {
                                  value: value.id,
                                  label: value.name,
                                };
                              })}
                              onChange={(event) => {
                                setFieldValue("universe_id", event.value);
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">Status</label>
                            <Select
                              name="status_id"
                              id="status_id"
                              className="react-select"
                              options={Array.from(statusList).map((value) => {
                                return {
                                  value: value.id,
                                  label: value.name,
                                };
                              })}
                              onChange={(event) => {
                                setFieldValue("status_id", event.value);
                              }}
                              isSearchable={true}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">Cover</label>

                            <div className="form-control w-100 m-0 ">
                              <label
                                className="mb-0 text-muted"
                                style={{ cursor: "pointer" }}>
                                Click here to upload images
                                <i
                                  className="fa fa-upload"
                                  aria-hidden="true"></i>
                                <Input
                                  id="image"
                                  type="file"
                                  accept="image/png , image/jpeg, image/webp"
                                  name="image"
                                  className="form-control d-none"
                                  onChange={onSelectFile}
                                />
                              </label>
                            </div>
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              JP Title
                            </label>
                            <Input
                              className="form-control"
                              id="jp_title"
                              name="jp_title"
                              placeholder="JP Title"
                              type="text"
                              value={values.jp_title}
                              onBlur={() => checkUniqueJPTitle()}
                              onChange={(event) => {
                                setJpTitle(event.target.value);
                                setFieldValue("jp_title", event.target.value);
                              }}
                            />
                            {isJpTitleUnique === false &&
                              <div className="text-danger text-align-top-center mt-1">
                                <span>Might be this title already exists, Please <Link to={`/admin/webtoon/webtoon-list?jp_title=${jpTitle}`}>'click here'</Link> to view label.</span>
                              </div>
                            }
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              KR Title
                            </label>
                            <Input
                              className="form-control"
                              id="kr_title"
                              name="kr_title"
                              placeholder="KR  Title"
                              type="text"
                              value={values.kr_title}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              Author(s)
                            </label>
                            <CreatableSelect
                              isMulti
                              isValidNewOption={() => true}
                              id="author_ids"
                              name="author_ids"
                              options={Array.from(authorList).map((value) => {
                                return {
                                  value: value.id,
                                  label: value.name,
                                };
                              })}
                              isOptionDisabled={() =>
                                selectedAuthors.length >= 3
                              }
                              onChange={(event) => {
                                const selectedAuthors = event.map(
                                  (e) => e.value
                                );
                                const existingAuthors = [];
                                const newAuthors = [];
                                selectedAuthors.map((x) => {
                                  if (UUIDv4.validate(x)) {
                                    existingAuthors.push(x);
                                  } else {
                                    newAuthors.push(x);
                                  }
                                });
                                setFieldValue("author_ids", existingAuthors);
                                setFieldValue("new_authors", newAuthors);
                                setSelectedAuthors(event);
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              Illustrator
                            </label>
                            <CreatableSelect
                              isMulti
                              id="illustrator_ids"
                              name="illustrator_ids"
                              options={Array.from(illustratorList).map(
                                (value) => {
                                  return {
                                    value: value.id,
                                    label: value.name,
                                  };
                                }
                              )}
                              isOptionDisabled={() =>
                                selectedIllustrator.length >= 3
                              }
                              onChange={(event) => {
                                const selectedIllustrator = event.map(
                                  (e) => e.value
                                );
                                const existingIllustrator = [];
                                const newIllustrator = [];
                                selectedIllustrator.map((x) => {
                                  if (UUIDv4.validate(x)) {
                                    existingIllustrator.push(x);
                                  } else {
                                    newIllustrator.push(x);
                                  }
                                });
                                setFieldValue(
                                  "illustrator_ids",
                                  existingIllustrator
                                );
                                setFieldValue(
                                  "new_illustrators",
                                  newIllustrator
                                );
                                setSelectedIllustrator(event);
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              No. of chpt
                            </label>
                            <Input
                              className="form-control"
                              id="no_of_volumes"
                              name="no_of_volumes"
                              placeholder=" No. of chpt"
                              type="number"
                              value={values.no_of_volumes}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              OnGoing
                            </label>
                            <Select
                              name="ongoing"
                              id="ongoing"
                              className=""
                              options={Array.from(onGoing).map((value) => {
                                return {
                                  value: value.id,
                                  label: value.name,
                                };
                              })}
                              onChange={(event) => {
                                setFieldValue("ongoing", event.value);
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">Type</label>
                            <Select
                              name="type_id"
                              id="type_id"
                              className="react-select"
                              options={Array.from(typeList).map((value) => {
                                return {
                                  value: value.id,
                                  label: value.name,
                                };
                              })}
                              onChange={(event) => {
                                setFieldValue("type_id", event.value);
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">Genre</label>
                            <Select
                              isMulti
                              name="genre_ids"
                              id="genre_ids"
                              className="select"
                              options={Array.from(genreList).map((value) => {
                                return {
                                  value: value.id,
                                  label: value.name,
                                };
                              })}
                              isOptionDisabled={() => selectedGenre.length >= 3}
                              onChange={(event) => {
                                setSelectedGenre(event);
                                setFieldValue(
                                  "genre_ids",
                                  event.map((e) => e.value)
                                );
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              Public Targeted
                            </label>
                            <Select
                              isMulti
                              name="public_ids"
                              id="public_ids"
                              className="select"
                              options={Array.from(publicList).map((value) => {
                                return {
                                  value: value.id,
                                  label: value.name,
                                };
                              })}
                              isOptionDisabled={() => selectedPublicTargeted.length >= 3}
                              onChange={(event) => {
                                setSelectedPublicTargeted(event)
                                setFieldValue(
                                  "public_ids",
                                  event.map((e) => e.value)
                                );
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              JP Platform
                            </label>
                            <Input
                              className="form-control"
                              id="jp_platform"
                              name="jp_platform"
                              placeholder="JP Platform"
                              type="text"
                              value={values.jp_platform}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              KR Platform
                            </label>
                            <Input
                              className="form-control"
                              id=" kr_platform"
                              name="kr_platform"
                              placeholder="KR Platform"
                              type="text"
                              value={values.kr_platform}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              US Platform
                            </label>
                            <Input
                              className="form-control"
                              id="us_platform"
                              name="us_platform"
                              placeholder="US Platform"
                              type="text"
                              value={values.us_platform}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              FR Platform
                            </label>
                            <Input
                              className="form-control"
                              id="fr_platform"
                              name="fr_platform"
                              placeholder="US Platform"
                              type="text"
                              value={values.fr_platform}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              JP platform likes / views / subscribers
                            </label>
                            <Input
                              className="form-control"
                              id="jp_platform_likes"
                              name="jp_platform_likes"
                              placeholder="JP platform likes / views / subscribers"
                              type="number"
                              value={values.jp_platform_likes}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              KR platform likes / views / subscribers
                            </label>
                            <Input
                              className="form-control"
                              id="kr_platform_likes"
                              name="kr_platform_likes"
                              placeholder="KR platform likes / views / subscribers"
                              type="number"
                              value={values.kr_platform_likes}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              US platform likes / views / subscribers
                            </label>
                            <Input
                              className="form-control"
                              id="us_platform_likes"
                              name="us_platform_likes"
                              placeholder="US platform likes / views / subscribers"
                              type="number"
                              value={values.us_platform_likes}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              FR platform likes / views / subscribers
                            </label>
                            <Input
                              className="form-control"
                              id="fr_platform_likes"
                              name="fr_platform_likes"
                              placeholder="FR platform likes / views / subscribers"
                              type="number"
                              value={values.fr_platform_likes}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        {permissions &&
                          permissions.map((permission) =>
                            permission === "create-webtoon-product-pl" ? (
                              <Col lg="3">
                                <FormGroup>
                                  <label className="form-control-label">
                                    Product P&L
                                  </label>
                                  <Input
                                    className="form-control"
                                    id="product_pl"
                                    name="product_pl"
                                    placeholder="Product P&L"
                                    type="text"
                                    value={values.product_pl}
                                    onChange={handleChange}
                                  />
                                </FormGroup>
                              </Col>
                            ) : (
                              ""
                            )
                          )}

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              JP Wikipedia
                            </label>
                            <Input
                              className="form-control"
                              id="jp_wikipedia_link"
                              name="jp_wikipedia_link"
                              placeholder="JP Wikipedia"
                              type="text"
                              value={values.jp_wikipedia_link}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              KR Wikipedia
                            </label>
                            <Input
                              className="form-control"
                              id="kr_wikipedia_link"
                              name="kr_wikipedia_link"
                              placeholder="KR Wikipedia"
                              type="text"
                              value={values.kr_wikipedia_link}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              JP Raw
                            </label>
                            <Input
                              className="form-control"
                              id="jp_raw"
                              name="jp_raw"
                              placeholder="JP Raw"
                              type="text"
                              value={values.jp_raw}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              ScanTrad
                            </label>
                            <Input
                              className="form-control"
                              id="scantrad"
                              name="scantrad"
                              placeholder="ScanTrad"
                              type="text"
                              value={values.scantrad}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        {permissions &&
                          permissions.map((permission) =>
                            permission === "create-webtoon-low-sale" ? (
                              <Col lg="3">
                                <FormGroup>
                                  <label className="form-control-label">
                                    Low Sales
                                  </label>
                                  <Input
                                    className="form-control"
                                    id="low_sales"
                                    name="low_sales"
                                    placeholder="Low Sales"
                                    type="number"
                                    value={values.low_sales}
                                    onChange={handleChange}
                                  />
                                </FormGroup>
                              </Col>
                            ) : (
                              ""
                            )
                          )}

                        {permissions &&
                          permissions.map((permission) =>
                            permission === "create-webtoon-medium-sale" ? (
                              <Col lg="3">
                                <FormGroup>
                                  <label className="form-control-label">
                                    Medium Sales
                                  </label>
                                  <Input
                                    className="form-control"
                                    id="medium_sales"
                                    name="medium_sales"
                                    placeholder="Medium Sales"
                                    type="number"
                                    value={values.medium_sales}
                                    onChange={handleChange}
                                  />
                                </FormGroup>
                              </Col>
                            ) : (
                              ""
                            )
                          )}

                        {permissions &&
                          permissions.map((permission) =>
                            permission === "create-webtoon-high-sale" ? (
                              <Col lg="3">
                                <FormGroup>
                                  <label className="form-control-label">
                                    High Sales
                                  </label>
                                  <Input
                                    className="form-control"
                                    id="high_sales"
                                    name="high_sales"
                                    placeholder="High Sales"
                                    type="number"
                                    value={values.high_sales}
                                    onChange={handleChange}
                                  />
                                </FormGroup>
                              </Col>
                            ) : (
                              ""
                            )
                          )}

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              FR consumer price
                            </label>
                            <Input
                              className="form-control"
                              id="fr_consumer_price"
                              name="fr_consumer_price"
                              placeholder="FR consumer price"
                              type="number"
                              value={values.fr_consumer_price}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              Is Active
                            </label>
                            <Select
                              name="is_active"
                              id="is_active"
                              className=""
                              options={Array.from(isActive).map((value) => {
                                return {
                                  value: value.id,
                                  label: value.name,
                                };
                              })}
                              onChange={(event) => {
                                setFieldValue("is_active", event.value);
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <HasPermission slug="create-flag">
                          <Col lg="3">
                            <FormGroup>
                              <label className="form-control-label">Flag</label>
                              <Select
                                isMulti
                                name="flag_users"
                                id="flag_users"
                                className="select"
                                options={Array.from(flagList).map((value) => {
                                  return {
                                    value: value.id,
                                    label: value.first_name,
                                  };
                                })}
                                onChange={(event) => {
                                  setFieldValue(
                                    "flag_users",
                                    event.map((e) => e.value)
                                  );
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </HasPermission>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              Comments
                            </label>
                            <textarea
                              className="form-control"
                              placeholder="comments..."
                              type="text"
                              name="comment"
                              id="comment"
                              value={values.comment}
                              onChange={handleChange}
                              rows={2}
                              cols={40}></textarea>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="3">
                          <Button
                            type="submit"
                            className="my-3 w-100"
                            color="primary">
                            {loading && (
                              <span
                                className="indicator-progress"
                                style={{ display: "block" }}>
                                Please Wait..
                                <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                              </span>
                            )}
                            {!loading && (
                              <span className="indicator-label">
                                Create Webtoon
                              </span>
                            )}
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </div>
              </Row>
              <CreateUniverses
                show={show}
                mediaType={"WEBTOON"}
                onClose={() => {
                  getUniverseList();
                  setShowModal(false);
                }}
              />
            </Container>
            {loader}
          </>
        </form>
      )}
    </Formik>
  );
};

export default () => (
  <ProtectedRoute requiredPermissions="create-webtoon">
    <CreateWebtoon />
  </ProtectedRoute>
);
